// the regex is taking what's is inside parenthesis ($1:$2)
// ignoring whitespaces
const regex = /\(\s*?(\S+)\s*?:\s*?(\S+)\s*?\)/gm;
/**
 * In some older browser like EdgeHTML 18|44
 * the MediaQueryListEvent.media is not respecting the spec.(the space after min-width|max-width)
 * the patch is to sanitize or uniforming the media strings on both sides
 * for example: 'screen and (min-width:768px)' !== 'screen and (min-width: 768px)'
 *
 * remove the white spaces in parenthesis if any
 * @param mediaQueryString {String}
 * @returns {String}
 */
export function sanitizeMediaQuery(mediaQueryString) {
  return mediaQueryString.replace(regex, '($1:$2)');
}
